/**
 * Polyfills for browser compatibility
 *
 * This module loads all necessary polyfills to ensure the application
 * works correctly across different browser versions.
 */

import { Temporal } from 'temporal-polyfill';

import './array-findlast.js';
import './array-tosorted.js';
import './array-tosorted.d.ts';

// Schedule-X validates with bare `Temporal` in its bundle; always expose our polyfill globally.
// temporal-spec (Schedule-X) vs temporal-polyfill types diverge only at compile time.
const globalWithTemporal = globalThis as typeof globalThis & { Temporal?: typeof Temporal };
globalWithTemporal.Temporal = Temporal as NonNullable<typeof globalWithTemporal.Temporal>;

// Add more polyfills here as needed
// import './other-polyfill';
